import React from 'react'
import "pages/Styles/PackageItem.sass"

export interface PackageItemData {
    title: string
    subtitle?: string
    isMain?: boolean
    badge?: string
}

interface PackageItemProps {
    item: PackageItemData
}

const PackageItem: React.FC<PackageItemProps> = ({ item }) => {
    return (
        <div className={`package-item ${item.isMain ? 'package-item--main' : ''}`}>
            <div className="package-item-content">
                <div className="package-item-title-row">
                    <div className="package-item-title">
                        {item.title}
                    </div>
                    {item.badge && (
                        <span className="package-spend-badge">{item.badge}</span>
                    )}
                </div>
                {item.subtitle && (
                    <div className="package-item-subtitle">
                        {item.subtitle}
                    </div>
                )}
            </div>
        </div>
    )
}

export default PackageItem

